<template>
  <div
    style="
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      padding: 20px;
    "
  >
    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; flex-grow: 1;">
      <v-avatar
        color="primary"
        class="appLogo"
      >
        <img
          :src="require('@/assets/images/appLogo.png')"
          alt="Logo"
          draggable="false"
          :style="appLogoSize == 'x-small'
            ? 'width: 25px; height: 25px;'
            : appLogoSize == 'small'
            ? 'width: 50px; height: 50px;'
            : appLogoSize == 'medium'
            ? 'width: 100px; height: 100px;'
            : 'width: 150px; height: 150px;'"
          style="object-fit: contain;"
        />
      </v-avatar>

      <template v-if="loadingText">
        <p style="color: #9e9e9e; margin-top: 10px;">
          {{ loadingText }}
          <template v-if="dotsToAnimate">
            <span v-for="i in display.dotsToAnimate" :key="i">.</span>
          </template>
        </p>
      </template>
    </div>

    <template v-if="navigation.hint">
      <div style="display: flex; flex-direction: row; align-items: center; gap: 5px;">
        <p style="color: #9e9e9e; font-size: small;"><span style="color: #3F51B5;"><strong>{{ navigation.hint.title }}:</strong></span> {{ navigation.hint.text }}</p>
        <template v-if="navigation.hint.icon">
          <v-icon size="x-small" color="indigo">{{ navigation.hint.icon }}</v-icon>
        </template>
      </div>
    </template>
  </div>
</template>

<style scoped>
  .appLogo {
    padding: 10px;
    animation: appLogoScaleAnimation 2s infinite, appLogoRotateAnimation 2s infinite, appLogoGlowAnimation 2s infinite;
    border: 2px solid #3F51B5;
  }

  @keyframes appLogoScaleAnimation {
    0% { transform: scale(1); }
    50% { transform: scale(1.05); }
    100% { transform: scale(1); }
  }

  @keyframes appLogoRotateAnimation {
    0% { transform: rotate(0deg) scale(1); }
    50% { transform: rotate(5deg) scale(1.05); }
    100% { transform: rotate(0deg) scale(1); }
  }

  @keyframes appLogoGlowAnimation {
    0% { box-shadow: 0 0 5px rgba(63,81,181,0.3); }
    50% { box-shadow: 0 0 15px rgba(63,81,181,0.6); }
    100% { box-shadow: 0 0 5px rgba(63,81,181,0.3); }
  }
</style>

<script>
  export default {
    name: 'AppLoaderScreen',
    props: {
      appLogoSize: {
        type: String,
        default: 'large'
      },
      loadingText: {
        type: String,
        default: 'Cargando...'
      },
      dotsToAnimate: {
        type: Number,
        default: null
      },
      hints: {
        type: Array,
        default: () => []
      }
    },

    data: () => ({
      navigation: {
        hint: null
      },
      display: {
        dotsToAnimate: []
      },
      interval: {
        dotsToAnimateInterval: null
      },
    }),

    methods: 
    {
      chooseRandomHint() {
        this.navigation.hint = this.hints[Math.floor(Math.random() * this.hints.length)];
      },
      startDotsToAnimateInterval() {
        this.interval.dotsToAnimateInterval = setInterval(() => {
          if (this.display.dotsToAnimate.length == this.dotsToAnimate) this.display.dotsToAnimate.length = 0;
          else this.display.dotsToAnimate.push('.');
        }, 500);
      }
    },

    mounted() {
      if (this.hints.length > 0) {
        this.chooseRandomHint();
      }
      if (this.dotsToAnimate) {
        this.startDotsToAnimateInterval();
      }
    },

    beforeUnmount() {
      if (this.interval.dotsToAnimateInterval) clearInterval(this.interval.dotsToAnimateInterval);
      this.interval.dotsToAnimateInterval = null;
    }
  }
</script>